import { Injectable } from '@angular/core';
import { Selector } from '@ngxs/store';
import { UiContextState } from './ui-context.state';
import { IUiContextState } from '../models/ui-context-state.model';

@Injectable()
export class UiContextSelector {
  @Selector([UiContextState])
  public static isSendEmailFormVisible(state: IUiContextState): boolean {
    return state.sendEmailFormVisible;
  }

  @Selector([UiContextState])
  public static isPromoCodeEditorVisbible(state: IUiContextState): boolean {
    return state.showPromoCodeForm;
  }

  @Selector([UiContextState])
  public static showEmailSentSuccesful(state: IUiContextState): boolean {
    return state.emailSuccessVisible ?? false;
  }

  @Selector([UiContextState])
  public static specifiedItemTypeId(
    state: IUiContextState
  ): number | undefined {
    return state?.specifiedItemTypeId;
  }

  @Selector([UiContextState])
  public static qqcAlertMessage(state: IUiContextState): string | undefined {
    return state?.qqcAlertMessage;
  }
}
